/**
 * Parse JSON only when the response declares application/json.
 * Avoids treating HTML error pages or empty bodies as successful `{}` parses.
 */
export async function parseResponseJson<T>(
  response: Response
): Promise<T | null> {
  const contentType = response.headers.get('content-type') || ''
  if (!/\bapplication\/json\b/i.test(contentType)) {
    return null
  }
  try {
    return (await response.json()) as T
  } catch {
    return null
  }
}
